import React from 'react';
import Icon from '../../../components/AppIcon';
import { Package, TrendingUp, DollarSign } from 'lucide-react';

export default function StatsOverview({ stats }) {
  const formatCurrency = (value) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    })?.format(value);
  };

  const statCards = [
    {
      title: "Total Items",
      value: stats?.totalItems || 0,
      icon: Package,
      color: "blue",
      bgColor: "bg-blue-50 dark:bg-blue-900/20",
      iconColor: "text-blue-600 dark:text-blue-400"
    },
    {
      title: "Items in Route",
      value: stats?.itemsInRoute || 0,
      icon: TrendingUp,
      color: "emerald",
      bgColor: "bg-emerald-50 dark:bg-emerald-900/20",
      iconColor: "text-emerald-600 dark:text-emerald-400"
    },
    {
      title: "Total Inventory Value",
      value: formatCurrency(stats?.totalInventoryValue || 0),
      icon: DollarSign,
      color: "purple",
      bgColor: "bg-purple-50 dark:bg-purple-900/20",
      iconColor: "text-purple-600 dark:text-purple-400"
    }
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-6">
      {statCards?.map((card, index) => (
        <div key={index} className={`bg-card rounded-lg border border-border p-4 elevation-1 ${card?.bgColor}`}>
          <div className="flex items-center justify-between mb-2">
            <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
              <Icon name={card?.icon} size={20} color={card?.iconColor} />
            </div>
            <span className="text-xs text-muted-foreground">{card?.title}</span>
          </div>
          <p className="text-2xl font-semibold text-foreground mb-1">{card?.value}</p>
        </div>
      ))}
    </div>
  );
}